export default __webpack_public_path__ + "static/media/internet-jeux.0c49b1cb.png";